import {
  CATCH_BOARD_VENUE_SEARCH_MIN_CHARS,
  CATCH_BOARD_VENUE_SEARCH_PAGE_SIZE,
} from 'src/screens/catch-board/catchBoardConstants'
import { getDefaultSpartacusDateRange } from 'src/utils/spartacusDateRange'
import { fetchSpartacusVenues } from 'src/utils/spartacusApi'

/**
 * Lightweight Spartacus venue search for Catch Board deal linking.
 * Reuses the Spartacus list endpoint (single source of truth — no duplicated venue data).
 *
 * @param {string} search
 * @param {{ pageSize?: number }} [options]
 * @returns {Promise<Array<{ venueId: string, name: string }>>}
 */
export async function searchCatchBoardVenues(search, { pageSize } = {}) {
  const trimmed = String(search || '').trim()
  if (trimmed.length < CATCH_BOARD_VENUE_SEARCH_MIN_CHARS) {
    return []
  }

  const { fromDate, toDate } = getDefaultSpartacusDateRange()
  const data = await fetchSpartacusVenues({
    fromDate: fromDate.toISOString(),
    toDate: toDate.toISOString(),
    page: 1,
    pageSize: pageSize || CATCH_BOARD_VENUE_SEARCH_PAGE_SIZE,
    sortBy: 'venueName',
    sortDir: 'asc',
    filters: JSON.stringify({ search: trimmed }),
  })

  const venues = Array.isArray(data?.venues) ? data.venues : []
  return venues
    .map(venue => {
      const venueId = venue?.venueId || venue?._id || null
      if (!venueId) {
        return null
      }
      return {
        venueId: String(venueId),
        // Spartacus list projects title → `name`; keep legacy keys as fallbacks.
        name:
          venue.name || venue.venueName || venue.title || 'Venue',
      }
    })
    .filter(Boolean)
}
